import React, { lazy, Suspense } from 'react';
import LoadingIndicator from '@wix/da-ds/pkg/LoadingIndicator';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import retry from '@wix/da-shared-react/pkg/utils/webpack/chunkRetry';
import LoadableRedux from '../../redux/ModuleLoaderLazy';
import { Props } from './types';

const LoadableModal = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "correspondence_modal" */
        './CorrespondenceModal'
      )
  )
);

const CorrespondenceModalLoadable: React.FC<Props> = props => (
  <ErrorBoundary debugComponent="CorrespondenceModalLoadable">
    <Suspense fallback={<LoadingIndicator view={'llama'} withOverlay usePortal />}>
      <LoadableRedux />
      <LoadableModal {...props} />
    </Suspense>
  </ErrorBoundary>
);
CorrespondenceModalLoadable.displayName = 'CorrespondenceModalLoadable';

export default CorrespondenceModalLoadable;
